angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {
    
    $stateProvider.state('dataDashboard', {
        url: '/dataDashboard/:id',
        controller: 'DataDashboardCtrl as vm',
        templateUrl: 'app/view/dataDashboard/dataDashboard.html',
    });    

}).controller('DataDashboardCtrl', function ($scope) {
 
    var vm = this;
    var destroy = $scope.$on("$destroy", function () {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});